import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const VISIBLE = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const LINE_HIDDEN = { y: "110%" };
const LINE_VISIBLE = { y: "0%" };

export const Reveal = ({ children, delay = 0, y = 36, className, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={VISIBLE}
    viewport={VIEWPORT}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className, lineClassName, delay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={`${line}-${i}`} className="overflow-hidden">
        <motion.div
          initial={LINE_HIDDEN}
          animate={LINE_VISIBLE}
          transition={{ duration: 1, delay: delay + i * 0.14, ease: EASE }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
